<template>
  <div :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="密码设置"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <div class="mybox" :style="{ height: pageHeight+ 'px' }" style="margin-top:46px;">
      <!-- <p style="color:#A2A1A0;padding:20px 0;text-align: justify;">更换手机号后，下次登录可以使用新手机号登录。当前手机号：15607164791</p> -->
      <van-form validate-first @failed="onFailed" @submit="onSubmit">
        <!-- 通过 pattern 进行正则校验 -->
        <van-field
          label="新密码"
          v-model="passWord"
          name="pattern"
          placeholder="请输入新密码"
        />
        <van-field
        v-model="passWordQR"
        center
        clearable
        label="确认密码"
        placeholder="请再次输入新密码"
      >
        <!-- <template #button>
          <van-button size="small" type="info">发送验证码</van-button>
        </template> -->
      </van-field>
        <div style="margin: 16px 0;">
          <van-button  block type="info" native-type="submit">确定</van-button>
        </div>
      </van-form>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, Col, Row, NavBar, Cell, CellGroup, Button, Form, Field } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Tabbar, TabbarItem, Col, Row, NavBar, Cell, CellGroup, Button, Form, Field)

export default {
  name: 'changepswPage',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Col.name]: Col,
    [Row.name]: Row,
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field
  },
  created () {},
  methods: {
    onClickLeft () {
      this.$router.go(-1)// 返回上一页面
    },
    onClickRight () {
    },
    onFailed (errorInfo) {
      // console.log('failed', errorInfo)
    },
    onSubmit () {
      // 不合法的手机号码
      if (!this.passWord) {
        this.util.toast('新密码不能为空')
        return
      }
      if (!this.passWordQR) {
        this.util.toast('请确认密码')
        return
      }
      this.util.post('/updatePW', {
        phoneNum: this.$route.query.phoneNum,
        passWord: this.passWord,
        passWordQR: this.passWordQR,
        userUpdatePWToken: this.$route.query.UserUpdatePWToken
      }).then(({ data }) => {
        if (data.code === 200) {
          // 登录按钮执行登录的时候，存localStorage
          localStorage.setItem('isLogin', 1) // 存储已登录信息
          localStorage.setItem('UserToken', data.data.UserToken)
          localStorage.setItem('passWord', this.passWordQR) // 存储密码
          this.util.toast(data.msg)
          setTimeout(() => {
            this.$router.replace({
              path: '/login'// 成功后到登录页
            })
          }, 1000)
        } else {
          // 验证失败
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    }
  },
  computed: {},
  data () {
    return {
      passWord: '',
      passWordQR: '',
      // pattern: /\d{6}/,
      pageHeight: window.innerHeight - 46
    }
  }
}
</script>

<style scoped lang="less">
/deep/.van-nav-bar__content {
  height: 46px;
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #A6A6A6;
}

</style>
